<template>
    <div>
      <img :src="signature"  v-show="signature.length > 0">
      <div class="btn btn-primary btn-big" v-if="update_allowed" v-show="signature.length == 0">
        <circle_check class="svg-24 svg-black"></circle_check> Click to sign
      </div>
    </div>
</template>

<script>

  export default {
      props: ['update_allowed', 'signature'],
    }
</script>
